/* ShowerNest – free shipping progress bars (top bar + cart boxes). Settings: section "Free shipping bar". */
(function () {
  if (window.__snFsbInit) return;
  window.__snFsbInit = true;
  var C = window.SN_FSB;
  if (!C) return;

  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>';
  var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  var thresholdCents = Math.round(parseFloat(C.threshold || '49.99') * 100 * rate);

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: currency || 'AUD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function fill(tpl, v) {
    return String(tpl || '')
      .split('[amount]').join(v.amount)
      .split('[threshold]').join(v.threshold)
      .split('[discount]').join(v.discount)
      .split('[items]').join(v.items)
      .split('[missing]').join(v.missing);
  }

  function render(cart) {
    var total = cart.total_price, count = cart.item_count, cur = cart.currency;
    var left = Math.max(0, thresholdCents - total);
    var empty = count === 0;
    var done = !empty && total >= thresholdCents;
    var pct = empty ? 0 : Math.min(100, (total / thresholdCents) * 100);
    var d = C.discount || {};
    var need = parseInt(d.minItems, 10) || 2;
    var v = {
      amount: money(left, cur),
      threshold: money(thresholdCents, cur),
      discount: d.label || '',
      items: need,
      missing: Math.max(0, need - count)
    };
    var T = C.texts;

    document.querySelectorAll('[data-sn-fsb="top"]').forEach(function (el) {
      el.classList.toggle('is-empty', empty);
      el.classList.toggle('is-done', done);
      el.querySelector('.sn-fsb__msg').innerHTML = fill(empty ? T.empty : done ? T.done : T.progress, v);
      el.querySelector('.sn-fsb__fill').style.width = pct + '%';
    });

    document.querySelectorAll('[data-sn-fsb="box"]').forEach(function (el) {
      var html, width, dots;
      if (d.enabled) {
        var two = count >= need;
        var msg = empty ? T.discEmpty : !done ? T.discHint : two ? T.discDone : T.discNext;
        width = empty ? 0 : done && two ? 100 : done ? 60 : Math.min(60, (total / thresholdCents) * 60);
        dots =
          '<span class="sn-fsb__dot' + (done ? ' is-on' : '') + '" style="left:60%">' + TRUCK + '<small>' + v.threshold + '</small></span>' +
          '<span class="sn-fsb__dot' + (done && two ? ' is-on' : '') + '" style="left:100%">%<small>' + need + ' items</small></span>';
        html = fill(msg, v);
        el.classList.toggle('is-done', done && two);
      } else {
        width = pct;
        dots = '<span class="sn-fsb__dot' + (done ? ' is-on' : '') + '" style="left:100%">' + TRUCK + '<small>' + v.threshold + '</small></span>';
        html = fill(empty ? T.cartEmpty : done ? T.cartDone : T.cartProgress, v);
        el.classList.toggle('is-done', done);
      }
      el.innerHTML =
        '<div class="sn-fsb__msg" role="status" aria-live="polite">' + html + '</div>' +
        '<div class="sn-fsb__track"><div class="sn-fsb__fill" style="width:' + width + '%"></div>' + dots + '</div>';
      el.hidden = false;
    });
  }

  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 150);
  }

  // Watch every cart change (theme forms, quantity buttons, bundle apps), whatever wraps fetch/XHR.
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (CART_RE.test(e.name.split('#')[0].replace(location.origin, ''))) refresh();
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  function start() {
    render({ total_price: C.cart.total, item_count: C.cart.count, currency: C.cart.currency });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
